// src/components/panel/DashboardSummaryCards.js
import React, { useState, useEffect } from 'react';
import { Card, Statistic, Row, Col, Typography, Spin } from 'antd';
import { DollarOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { NODE_BACKEND_API_URL } from '../../config';
import { useAfipHealth } from '../../context/AfipHealthContext';

const DashboardSummaryCards = () => {
    // Dolar state
    const [dolarData, setDolarData] = useState(null);
    const [dolarLoading, setDolarLoading] = useState(true);

    // Uptime state — not used in demo mode
    const [uptimeData, setUptimeData] = useState(null);
    const [uptimeLoading, setUptimeLoading] = useState(process.env.REACT_APP_DEMO_MODE !== 'true');

    // AFIP health from the shared context (single poller app-wide)
    const { afipHealth, isLoading: afipLoading } = useAfipHealth();

    useEffect(() => {
        // Fetch Dolar data
        axios.get(`https://dolarapi.com/v1/dolares/oficial`)
            .then(res => {
                setDolarData(res.data);
                setDolarLoading(false);
            })
            .catch(err => {
                console.error("Error fetching dolar data:", err);
                setDolarLoading(false);
            });

        // Fetch server uptime (skipped in demo — it's a real-server metric)
        if (process.env.REACT_APP_DEMO_MODE !== 'true') {
            axios.get(`${NODE_BACKEND_API_URL}/getuptime`)
                .then(res => {
                    setUptimeData(res.data);
                    setUptimeLoading(false);
                })
                .catch(err => {
                    console.error("Error fetching uptime data:", err);
                    setUptimeLoading(false);
                });
        }
    }, []);

    return (
        <Row gutter={8} style={{ marginBottom: 8, display: 'flex' }}>
            {/* Server Uptime Card */}
            <Col xs={24} sm={8} style={{ display: 'flex' }}>
                <Card size="small" style={{ borderLeft: '4px solid #15bd2e', width: '100%' }}>
                    {uptimeLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spin tip="Cargando..." />
                        </div>
                    ) : (
                        <Statistic
                            title={<Typography.Text style={{ fontSize: '16px', fontWeight: 600 }}>Servidor Uptime</Typography.Text>}
                            value={process.env.REACT_APP_DEMO_MODE === 'true' ? 90 : (uptimeData?.days || 0)}
                            suffix="días"
                            prefix={<CheckCircleOutlined />}
                            valueStyle={{ color: '#15bd2e', fontSize: '24px' }}
                        />
                    )}
                </Card>
            </Col>

            {/* AFIP Status Card */}
            <Col xs={24} sm={8} style={{ display: 'flex' }}>
                <Card 
                    size="small" 
                    style={{ 
                        borderLeft: `4px solid ${afipLoading ? '#8c8c8c' : (afipHealth?.isHealthy ? '#40a9ff' : '#ff4d4f')}`, 
                        width: '100%' 
                    }}
                >
                    {afipLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spin tip="Verificando..." />
                        </div>
                    ) : (
                        <Statistic
                            title={<Typography.Text style={{ fontSize: '16px', fontWeight: 600 }}>Conexión AFIP/ARCA</Typography.Text>}
                            value={afipHealth?.isHealthy ? 'Online' : 'Offline'}
                            prefix={afipHealth?.isHealthy ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                            valueStyle={{ 
                                color: afipHealth?.isHealthy ? '#40a9ff' : '#ff4d4f', 
                                fontSize: '24px' 
                            }}
                        />
                    )}
                </Card>
            </Col>

            {/* Dolar Oficial Card */}
            <Col xs={24} sm={8} style={{ display: 'flex' }}>
                <Card size="small" style={{ borderLeft: '4px solid #0F9D58', width: '100%' }}>
                    {dolarLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spin tip="Cargando..." />
                        </div>
                    ) : (
                        <Statistic
                            title={<Typography.Text style={{ fontSize: '16px', fontWeight: 600 }}>Dólar Oficial</Typography.Text>}
                            value={dolarData?.venta || 0}
                            precision={2}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#0F9D58', fontSize: '24px' }}
                            suffix={
                                <Typography.Text style={{ fontSize: '13px', color: '#8c8c8c' }}>
                                    (Compra: ${dolarData?.compra?.toFixed(2) || '0.00'})
                                </Typography.Text>
                            }
                        />
                    )}
                </Card>
            </Col>
        </Row>
    );
};

export default DashboardSummaryCards;
